import React from "react";
import { SERVICES } from "../../lib/services";

/** Badge « Nettoyage » / « Espaces verts ». */
const ServiceBadge = ({ service = "clean", size = "xs", testid }) => {
  const s = SERVICES[service] || SERVICES.clean;
  const Icon = s.icon;
  const dim = size === "xs" ? "text-[11px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span className={`inline-flex items-center gap-1 font-semibold rounded-full ${dim} ${s.cls}`} data-testid={testid || `service-badge-${service}`}>
      <Icon size={11} /> {s.label}
    </span>
  );
};

/** Sélecteur Nettoyage / Espaces verts (boutons segmentés). */
export const ServicePicker = ({ value = "clean", onChange, testid = "service-picker" }) => (
  <div className="inline-flex rounded-md border border-neutral-300 overflow-hidden" data-testid={testid}>
    {Object.entries(SERVICES).map(([k, s]) => {
      const Icon = s.icon;
      const on = value === k;
      return (
        <button type="button" key={k} onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
          className={`flex items-center gap-1.5 text-sm px-3 py-2 transition-colors ${on ? "bg-brand text-white" : "bg-white text-neutral-600 hover:bg-neutral-50"}`}>
          <Icon size={14} /> {s.label}
        </button>
      );
    })}
  </div>
);

export default ServiceBadge;
